const Title = {
	title: 'p-[8px] grow select-none relative'
}
export default Title
